var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MultiLineButton',{attrs:{"text":_vm.$t('shooting.buttons.sendBackDMS'),"loading":_vm.loadingReplayDMS},on:{"click":_vm.replayDMS}})
}
var staticRenderFns = []

export { render, staticRenderFns }